import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { FaRegEdit } from 'react-icons/fa';
import { FiShare2 } from 'react-icons/fi';
import { MdHomeFilled, MdOutlineMonetizationOn } from 'react-icons/md';
import { TbChecklist } from 'react-icons/tb';
import styled from 'styled-components';
import { media } from 'utils/media';
import Container from './Container';

export default function SecondNavbar() {
  const router = useRouter();
  const pathUrl = router.asPath;

  return pathUrl !== '/profile/user' && pathUrl !== '/new-event' ? (
    <NavbarContainer>
      <Content>
        <ul>
          <NextLink href="/profile/user">
            <div>
              <li>
                <MdHomeFilled size={30} color="#174F68" style={{ marginRight: '10px' }} />
                <p>Home</p>
              </li>
            </div>
          </NextLink>
          <NextLink href="#">
            <div>
              <li>
                <TbChecklist size={30} color="#174F68" style={{ marginRight: '10px' }} />
                <p>Convidados</p>
              </li>
            </div>
          </NextLink>
          <NextLink href={'#'}>
            <div>
              <li>
                <FaRegEdit size={30} color="#174F68" style={{ marginRight: '10px' }} />
                <p>Convite</p>
              </li>
            </div>
          </NextLink>
          <NextLink
            href={`#`}
          >
            <div>
              <li>
                <FiShare2 color="#174F68" size={30} style={{ marginRight: '10px' }} />
                <p>Compartilhar</p>
              </li>
            </div>
          </NextLink>
          <NextLink href={`#`}>
            <div>
              <li>
                <MdOutlineMonetizationOn size={30} color="#174F68" style={{ marginRight: '10px' }} />
                <p>Financeiro</p>
              </li>
            </div>
          </NextLink>
        </ul>
      </Content>
    </NavbarContainer>
  ) : null;
}

const NavbarContainer = styled.div`
  display: flex;
  position: block;
  top: 0;
  padding: 1.5rem 0;
  width: 100%;
  height: 6rem;
  z-index: var(--z-navbar);
  background-color: #fff6e8;
  border-bottom: 1px solid #174F68;
`;

const Content = styled(Container)`
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    :hover {
      border-bottom: 2px solid #174F68;
    }
  }
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 30px;
    list-style-type: none;
  }
  li {
    margin: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    color: #174F68;
    @media (max-device-width: 660px) {
      top: 20px;
      display: inline;
      align-items: center;
      width: 100px;
      p {
        margin-top: 0.5rem;
        margin-right: 2rem;
        display: none;
      }
      img {
        margin-top: 1rem;
        max-width: 100%;
      }
    }
  }
  img {
    max-width: 30px;
    margin-right: 1rem;
  }
  ${media('<=desktop')} {
    img {
      max-width: 25px;
    }
    li {
      margin-left: 10px;
    }
  }
`;
